import React from "react";
import styles from "../staff.module.scss";
import AccountImage from "assets/images/account_circle.svg";
import defaultUserImage from "assets/images/staff-default.svg";

const StaffProfileSection = ({
  profilePic,
  firstName,
  lastName,
  colourCode,
}) => {
  return (
    <>
      <div className="staff-pic">
        {profilePic ? (
          <img
            src={profilePic}
            alt="staff"
            onError={(e) => {
              e.currentTarget.src = defaultUserImage;
            }}
          />
        ) : (
          <img src={defaultUserImage} alt="staff" />
        )}
      </div>
      <div
        className={styles["user-name-parent"]}
      >
        <div
          className={styles["user-profile-container"]}
          style={{ backgroundColor: colourCode }}
        >
          <img
            src={AccountImage}
            alt="account"
            className="account_owner_image"
            onError={(e) => {
              e.currentTarget.src = defaultUserImage;
            }}
          />
          <p className={styles.account_owner_name}>
            {firstName} {lastName}
          </p>
        </div>
      </div>
    </>
  );
};

export default StaffProfileSection;
